module.exports = __webpack_public_path__ + "static/media/1-4-1.d5e9ce74.png";